import { t } from 'i18next';
import { noop } from 'lodash-es';
import { useCallback } from 'react';

import { InfiniteQuery, InfiniteQueryOption } from './constants';

const data: InfiniteQueryOption[] = [
  {
    label: t('dispatch.dispatch_v2.filters.digital_ticket_orders'),
    value: 'true',
  },
  {
    label: t('dispatch.dispatch_v2.filters.paper_ticket_orders'),
    value: 'false',
  },
];

export default function useTicketTypesInfiniteQuery(): InfiniteQuery {
  const noopFn = useCallback(() => {
    return noop;
  }, []);

  return {
    clear: noopFn,
    data,
    fetch: noopFn,
    fetchMore: undefined,
    isDummyQuery: true,
  };
}
